<template>
    <b-row> 
        <b-card-group class="col-12" v-for="(item, index) of items" :key="index" >
            <b-card class="shadow-lg my-3">
                <b-row >
                    <b-col class="col-sm-2 d-none d-sm-block">
                        <b-card-img :src="item.imagen" alt="Image" class="mb-5" style="cursor: pointer" @click.prevent="$emit('item-info', item)"></b-card-img>
                    </b-col>
                    <b-col class="col-12 col-sm-7">
                        <b-card-text>
                            <a class="item-name" @click.prevent="$emit('item-info', item)">{{item.nombre}}</a> <br>
                            <div class="item-detail">
                                Item: {{item.codigo}} <br>
                                <div v-if="user.tipo_terceros == 1">
                                    <b v-if="user.isMaster">{{ item.quantity }}</b>
                                    <b v-else :class="$getSimpleStockClass(item.quantity)">{{ $getSimpleStockMessage(item.quantity) }}</b>
                                </div>
                                <div>Código de Barras: <strong> {{item.codigo_barras}} </strong> </div>
                                <div v-if="show_supplier_price && user.isMaster">Precio Proveedor con Imp: <strong>$ {{ numberFormat(item.precio_final_prov_imp) }}</strong></div>
                            </div>
                        </b-card-text>
                    </b-col>
                    <b-col class="col-12 col-sm-3">
                        <div v-if="item.prices_by_quantity_array.length > 0">
                            <b>Precio por Volumen de Compra:</b>
                            <div v-for="(price, index) in item.prices_by_quantity_array" :key="index">
                                <ul>
                                    <li>
                                        <b>{{price.quantity}}</b> unidades: 
                                        <span class="price-item-quantities"> ${{numberFormat(price.precio_final_con_imp)}} </span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="producto-agotado" v-if="item.quantity == '0'">
                            <strong>Producto Agotado</strong>
                        </div>
                    </b-col>
                </b-row>
                <template #footer>
                    <Footer :item="item" />
                </template>
            </b-card>
        </b-card-group>
    </b-row>
</template>

<script>
import Footer from './Footer.vue'
import { mapState} from 'vuex'
export default {
    name: "CardItem3",
    props: {
        items: {
            type: Array
        }       
    },
    computed: {
        ...mapState('auth', ['user']),
        ...mapState('configuration', ['background', 'show_supplier_price']),
        cssVars() {
            return {
                '--border-bottom': this.background
            };
        },
    },
    components: {
        Footer
    },

};

</script>
<style scoped>
.card-img { 
    max-width: 100%; 
    max-height: 150px;
    object-fit: scale-down;
}

.card-text {
    font-size: 14px;
}

.producto-agotado{
    font-size: 18px;
    color: red;
}

.price-size{
    font-size: 18px;
}

.icon-info{
    color: var(--border-bottom);
    cursor: pointer;
}

</style>